import { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';

import { EButton, EModal } from 'libs/ui';
import { showToast } from 'utils/utility';
import { useFlightData, useHotelData } from 'libs/data-access';

interface IProps {
    service: "FLIGHT" | "HOTEL";
    bookingId: string;
    handleRefresh: () => void;
};

export default function RefundTicket({ ...props }: IProps) {

    const { postFlightData } = useFlightData();
    const { postHotelData } = useHotelData();

    const [confirmRefund, { open: openConfirmRefund, close: closeConfirmRefund }] = useDisclosure(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);


    const refundTicket = async () => {
        setIsSaving(true);

        const response = await props.service === "FLIGHT"
            ? postFlightData(`/booking/${props.bookingId}/refund-booking-amount`, null)
            : postHotelData(`/booking/${props.bookingId}/refund-booking-amount`, null);

        if ((await response).isSuccess) {
            // console.log("Response for refunding ticket: ", response);
            showToast({
                type: "success",
                message: "Ticket refunded successfully!"
            });
            props.handleRefresh();
        } else {
            console.log("Error while refunding ticket: ", response);
            showToast({
                type: "error",
                message: (await response).message || "Error while refunding ticket!"
            });
        };

        setIsSaving(false);
    };


    return (
        <>
            <EButton
                size="sm"
                variant="light"
                color="green"
                onClick={openConfirmRefund}
            >Refund</EButton>

            <EModal
                opened={confirmRefund}
                onClose={closeConfirmRefund}
            >
                <div className="flex flex-col gap-6">
                    <p className="text-base font-semibold">Are you sure you want to initiate refund?</p>
                    <div className="flex justify-end gap-2">
                        <EButton
                            size="sm"
                            variant="light"
                            color="gray"
                        >No</EButton>
                        <EButton
                            size="sm"
                            loading={isSaving}
                            onClick={refundTicket}
                        >Yes</EButton>
                    </div>
                </div>
            </EModal>
        </>
    );

}